@if (game().isUnlocked || isGameOpenByTag() || (isMaintenance() && user().isTester)) {
  <div
    class="c-game"
    [ngClass]="isMaintenance() ? 'c-game--maintenance' : ''">
    @if (game().tags?.[0] && showTag()) {
      <img
        class="c-game__tag"
        [src]="gameTagUrl()"
        loading="lazy"
        draggable="false" />
    }
    <img
      class="c-game__icon"
      [ngClass]="isMaintenance() && !user().isTester ? 'c-game__icon--maintenance' : ''"
      [src]="gameIconImg()"
      [alt]="game().gameTitle"
      loading="lazy"
      avoidMulticlick
      (safeClick)="goToGame(game())"
      draggable="false"
      (load)="isIconLoaded.set(true)" />
    @if (!isMaintenance() && game().trophy) {
      <slotcom-game-trophy-progress
        [trophy]="game().trophy"
        [game]="game()"
        [gameView]="false">
      </slotcom-game-trophy-progress>
    } @else if (!game().trophy && isGameOpenByTag()) {
      <slotcom-game-trophy-progress
        [game]="game()"
        [gameView]="false"
        [locked]="true"
        #tooltipTrophy="slotcomTooltip"
        [slotcomTooltipDisabled]="false"
        [slotcomTooltip]="'home.trophies.casino-not-reached' | translate: { x: 20 }"
        slotcomTooltipPosition="left"
        slotcomTooltipClass="slotcom-tooltip--right"
        (click)="tooltipTrophy.toggle()">
      </slotcom-game-trophy-progress>
    }
  </div>
} @else {
  <div
    class="c-game c-game--locked"
    [ngClass]="isMaintenance() ? 'c-game--maintenance' : ''">
    @if (game().tags?.[0] && showTag()) {
      <img
        class="c-game__tag"
        [src]="gameTagUrl()"
        loading="lazy"
        draggable="false" />
    }
    <img
      class="c-game__icon c-game__icon--locked"
      [src]="gameIconImg()"
      [alt]="game().gameTitle"
      loading="lazy"
      draggable="false"
      (load)="isIconLoaded.set(true)" />

    @if (!isMaintenance()) {
      <div class="c-unlock__hover">
        {{ 'home.trophies.casino-not-reached' | translate }}
      </div>

      @if (game().trophy) {
        <slotcom-game-trophy-progress
          [trophy]="game().trophy"
          [game]="game()"
          [gameView]="false">
        </slotcom-game-trophy-progress>
      }
    }
  </div>
}
@if (!isIconLoaded()) {
  <div class="c-game--loading"></div>
}
